/**
 * Created by mozartdiniz on 12/2/14.
 */
Greenmile.Survey.Sidebar.DECIMAL = function () {

    this.resourceKey = 'Survey.Sidebar.Number';
    this.jsonType = 'DECIMAL';

    Greenmile.Survey.Sidebar.Generic.apply(this, arguments);
};